import React, { createContext, useContext, useState, useEffect } from "react";
import API from "../config/api";
// Fallback to static contacts if API fails
import staticContacts from "../data/contacts";

const ContactsContext = createContext(null);

// Utility function to transform contacts data with computed fields
const transformContacts = (data, fallback = staticContacts) => ({
  ...data,
  MAILTO: `mailto:${data.CONTACT_EMAIL || fallback.CONTACT_EMAIL}`,
  PHONE_TEL: `tel:${(data.PHONE_DISPLAY || fallback.PHONE_DISPLAY).replace(/\s/g, '')}`,
  ADDRESS_LINE: data.SHOWROOM_ADDRESS || fallback.SHOWROOM_ADDRESS,
});

export const ContactsProvider = ({ children }) => {
  const [contacts, setContacts] = useState(transformContacts(staticContacts));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await fetch(API.ENDPOINTS.CONTACTS);
        const data = await response.json();
        // Validate that the data contains required fields
        if (data && data.CONTACT_EMAIL && data.COMPANY_NAME) {
          setContacts(transformContacts(data));
        }
      } catch (error) {
        console.error("Error fetching contacts:", error);
        // Keep static contacts as fallback
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, []);

  return (
    <ContactsContext.Provider value={{ contacts, loading }}>
      {children}
    </ContactsContext.Provider>
  );
};

export const useContacts = () => {
  const context = useContext(ContactsContext);
  if (!context) {
    throw new Error("useContacts must be used within a ContactsProvider");
  }
  return context;
};

export default ContactsContext;
